import React from 'react'
import Yup from '../../../../helpers/custom-yup'
import Modal from '../../../../components/modal/modal.component'
import Title from '../../../../components/typography/title.component'
import moment from 'moment'
import Button from '../../../../components/buttons/buttons.component'
import AntiFraud from '../../../../components/form-components/anti-fraud.component'
import LinkButton from '../../../../components/buttons/link-button.component'
import InnerPageContainer from '../../../../components/layout/private/inner-page-container.component'
import { Formik } from 'formik'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { CardInfo } from '../../../../components/credit-cards/card-info.component'
import { TextInput } from '../../../../components/form-components/inputs.component'
import { PlansTable } from '../../../../components/layout/plans-table/plans-table.component'
import { withRouter } from 'react-router-dom'
import { ClubService } from '../../../../services/club.service'
import { bindActionCreators } from 'redux'
import { Creators as SiteCreators } from '../../../../ducks/site/site'
import { mapRecurrenceTypeFromEnglishToPortuguese } from '../../../../helpers/plans.helper'
import {
	userActions,
	toastActions,
	creditCardsActions
} from '../../../../actions'


class CancelSubscriptionPage extends React.Component {
	state = {
		cancelPlanModalIsOpen: false,
		planId: null,
		recurrenceType: null,
		modalIsOpen: false,
		newPlan: null,
		planExpirationDate: moment()
			.add(1, 'year')
			.format('DD/MM/YYYY')
	}

	componentWillMount() {
		this.props.updatePlan()
		this.props.getCards()
	}

	onSubmitCancelation = async ({ reason }) => {
		const {
			history,
			danger,
			updatePlan,
			showLoading,
			hideLoading
		} = this.props

		showLoading()

		ClubService.unsubscribe({ cancelationReason: reason })
			.then(({ success, errors }) => {
				if (success) {
					updatePlan()
					hideLoading()
					history.push(`${routes.CLIENTE}/planos`)
				} else {
					hideLoading()
					danger({ message: errors[0] })
				}
			})
			.catch(error => {
				hideLoading()
				danger({ message: error })
			})
	}

	onChangePlan = (id, recurrenceType) => () => {
		this.setState({ planId: id, recurrenceType }, async () => {
			ClubService.getPlans()
				.then(plans =>
					this.setState(
						{ newPlan: plans.filter(plan => plan.id == id)[0] },
						() => this.setState({ modalIsOpen: true })
					)
				)
				.catch(console.log)
		})
	}

	onSubmit = async ({ securityCode }) => {
		const { planId, recurrenceType } = this.state

		const {
			creditCards,
			deviceId,
			hideLoading,
			showLoading,
			danger,
			success,
			updatePlan
		} = this.props

		showLoading()

		const data = {
			securityCode,
			planId,
			cardId: creditCards.filter(card => card.main)[0].id,
			recurrenceType: mapRecurrenceTypeFromEnglishToPortuguese(
				recurrenceType
			),
			deviceId
		}

		ClubService.changePlan(data)
			.then(data => {
				if (data.success) {
					this.setState({ modalIsOpen: false })
					success({
						message: 'Parabéns! Seu plano foi alterado com sucesso'
					})
					updatePlan()
				} else {
					danger({ message: data.errors })
				}

				hideLoading()
			})
			.catch(error => {
				hideLoading()
				danger({ message: error })
			})
	}

	render() {
		const {
			cancelPlanModalIsOpen,
			recurrenceType,
			modalIsOpen,
			newPlan
		} = this.state

		const { plan } = this.props

		return (
			<InnerPageContainer>
				<AntiFraud />
				<Title>Clube Muviflex</Title>

				<h3 className="orange semi-bold">
					Confira outras opções de planos disponíveis
				</h3>
				<PlansTable logged onButtonClick={this.onChangePlan} />
				<div
					style={{
						display: 'flex',
						justifyContent: 'flex-end',
						marginTop: '4rem'
					}}>
					<Button
						secondary
						onClick={() => this.setState({ cancelPlanModalIsOpen: true })}
						style={{ marginRight: '15px' }}>
						Desejo cancelar o meu plano
					</Button>
					<LinkButton to={`${routes.CLIENTE}/loja-muviflex`}>
						Desejo continuar com o meu plano
					</LinkButton>
				</div>
				<Modal
					ref="cancelationModal"
					isOpen={cancelPlanModalIsOpen}
					onClose={() => this.setState({ cancelPlanModalIsOpen: false })}>
					<p>Você poderia nos informar o motivo do cancelamento?</p>
					<Formik
						onSubmit={this.onSubmitCancelation}
						initialValues={{ reason: '' }}
						render={props => (
							<form noValidate onSubmit={props.handleSubmit}>
								<TextInput id="reason" {...props} />
								<div
									style={{
										marginTop: '4rem',
										display: 'flex',
										justifyContent: 'flex-end'
									}}>
									<Button primary type="submit">
										Enviar
									</Button>
								</div>
							</form>
						)}
					/>
				</Modal>
				<Modal
					ref="modal"
					isOpen={modalIsOpen}
					title="Alteração de plano"
					onClose={() => this.setState({ modalIsOpen: false })}>
					<p>
						Aviso! Nas trocas de plano para um Tipo de plano com pagamento
						anual, uma nova cobrança será feita no momento da confirmação
						da mudança, assim como um novo crédito de pontos será
						efetuado.
						<br />
					</p>
					{newPlan && (
						<p>
							Plano {newPlan.name} <br />
							Valor do pagamento:{' '}
							{recurrenceType == 'monthly'
								? Number(newPlan.amount).$toReais()
								: Number(newPlan.annualAmmount).$toReais()}{' '}
							<br />
							{recurrenceType == 'monthly' &&
								`Data da cobrança: Todo dia ${plan.billingDay}`}
							<br />
							{recurrenceType == 'yearly' &&
								`Data de término do plano: ${planExpirationDate}`}
							<br />
							Renovação: Automática
						</p>
					)}
					<Formik
						initialValues={{ securityCode: '' }}
						validationSchema={Yup.object().shape({
							securityCode: Yup.string().required(
								'Informe o código de segurança'
							)
						})}
						onSubmit={this.onSubmit}
						render={props => (
							<form noValidate onSubmit={props.handleSubmit}>
								<CardInfo {...props} />
								<p>Você confirma a alteração de plano?</p>
								<div
									style={{
										display: 'flex',
										justifyContent: 'flex-end'
									}}>
									<Button
										secondary
										style={{ marginRight: '15px' }}
										onClick={this.refs.modal.close}
										type="button">
										Não
									</Button>
									<Button primary type="submit">
										Sim
									</Button>
								</div>
							</form>
						)}
					/>
				</Modal>
			</InnerPageContainer>
		)
	}
}

const mapStateToProps = ({ creditCards, antiFraud, user }) => ({
	creditCards: creditCards.creditCards,
	deviceId: antiFraud.sessionID,
	plan: user.plan || null
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			danger: toastActions.danger,
			success: toastActions.success,
			updatePlan: userActions.updatePlan,
			getCards: creditCardsActions.getCards,
			hideLoading: SiteCreators.hideLoading,
			showLoading: SiteCreators.showLoading
		},
		dispatch
	)

const connectedCancelSubscriptionPage = withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(CancelSubscriptionPage)
)

export { connectedCancelSubscriptionPage as ModuleRootComponent }
